import Tab from "//charcoalclothing.com.au/cdn/shop/t/216/assets/sl-module-tab.js?v=53873693089971621431780962158"

// Reposition mega menu to fill gaps
function resizeGridItem(item){
  let grid = document.getElementsByClassName("megamenu-grid")[0];
  let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
  let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
  let rowSpan = Math.ceil((item.querySelector('.megamenu-content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
  item.style.gridRowEnd = "span "+rowSpan;
}

function resizeAllGridItems(){
  let allItems = document.getElementsByClassName("megamenu-grid__item");
  for(let x=0;x<allItems.length;x++){
    resizeGridItem(allItems[x]);
  }
}

function resizeInstance(instance){
  item = instance.elements[0];
  resizeGridItem(item);
}

window.onload = resizeAllGridItems();
window.addEventListener("resize", resizeAllGridItems);
  
// Slider on feature collection sections
const featuredCollectionSliders = document.querySelectorAll('.product-slider .grid');
const initSlider = elem => {
  let flkty = new Flickity(elem, {
    cellAlign: 'right',
    wrapAround: false,
    pageDots: false,
    contain: true,
    prevNextButtons: false,
    imagesLoaded: true
  });

  document.addEventListener('swatchColors:loaded', e => {
    flkty.resize();
  });
}
featuredCollectionSliders.forEach(initSlider);

$('#scroll-up').on('click', function() {
  window.scrollTo({top: 0, behavior: 'smooth'});
});


// Product Grid - Add to cart
theme.productGridAddToCart = async e => {
  const self = e.target;
  const selectedVariant = e.target.dataset.variantId;

  let items = [];
  let obj = {
    id: JSON.parse(selectedVariant),
    quantity: 1
  }

  items.push(obj)

  if (!selectedVariant) return;
  try {
    self.classList.add('btn--loading');

    const res = await fetch(theme.routes.cartAdd, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    });

    const data = await res.json();
    
    if(res.ok) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data,
          addToCartBtn: self
        }
      }));
    }
  }
  catch (err) {
    self.classList.remove('btn--loading');
  }
  finally {
    self.classList.remove('btn--loading');
  }
}

const pgAtcBtnsFunction = () => {
  document.querySelectorAll('.js-product-grid-atc').forEach((element) => {
    // Fix to prevent multiple add.js calls
    if (element.dataset.ajaxBound === '1') return;
    element.dataset.ajaxBound = '1';

    element.addEventListener('click', function(e) {
      e.preventDefault();
      theme.productGridAddToCart(e);
    });
  });
};

$(document).ready(function() {
  pgAtcBtnsFunction();
});

// PLP load more
$('.js-load-more').on('click', function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  $this.find('[loader]').addClass('btn--loading');
  var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
      let items = $('.grid-product').length;
      $('.current-count').text(items);
      if (window.AOS) { AOS.refreshHard() }
      document.dispatchEvent(new CustomEvent('plpMoreLoaded'));
      pgAtcBtnsFunction();
    },
    complete: function() {
      if(currentPage <= totalPages) {
         $this.attr('disabled', false); $this.find('[loader]').removeClass('btn--loading');
      } 
    }
  })
});

// Scroll to top
const scrollToTop = e => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c === 0) return;
  window.scrollTo({top: 0, behavior: 'smooth'});   
}


// Initializes after dom is fully loaded
const domReady = e => {
  // Activate all tab components
  const tabs = document.querySelectorAll('.js-component-tab');
  tabs.forEach(tab => {
    new Tab(tab)
  });


  // Scroll to top button
  const scrollToTopButton = document.querySelector('.js-scroll-to-top');
  scrollToTopButton?.addEventListener('click', scrollToTop, false);
}
document.addEventListener('DOMContentLoaded', domReady, false);


// Calculate height of product meta section and adjust height of image container
// $(document).ready(function() {
//     const width = window.innerWidth;
//     if(width > 769) {
//       let containerHeight = $('.product-single__meta').innerHeight() + 'px';
//       $('.product__photos').css("height", containerHeight);
//     }
// });

// Moving background variant selector

theme.initialSelectedItem = function() {
  const target = $(".background-highlight");
  target.each(function() {
    const variants = $(this).siblings(".variant-input").find('label');
    const currentVariant = $(this).siblings(".variant-input").find('input[name="Size"]:checked+label');

    for (let i = 0; i < variants.length; i++) {
      variants[i].addEventListener("click", variantClick);
    }

    if (currentVariant.length == 0) {
      return;
    }

    const width = currentVariant.innerWidth();
    const height = currentVariant.innerHeight();
    const left = currentVariant.position().left;
    const top = currentVariant.position().top;
    $(this).css({"width": `${width}px`, "height": `${height}px`, "left":`${left}px`, "top":`${top}px`});

    // Update Restock Alert
    let restockSelect = document.querySelector('select[name="da-restock-alerts-variant"]');
    let restockSelectOptions = document.querySelectorAll('select[name="da-restock-alerts-variant"] option');
    let size = currentVariant[0].innerHTML;

    for (let i = 0; i < restockSelectOptions.length; i++) {
      if (restockSelectOptions[i].label == size) {
        restockSelect.selectedIndex = i;
        break;
      }
    }
  });

}

function variantClick() {
  const target = $(this).parents(".variant-input-wrap").children(".background-highlight");
  const width = $(this).innerWidth();
  const height = $(this).innerHeight();
  const left = $(this).position().left;
  const top = $(this).position().top;
  target.css({"width": `${width}px`, "height": `${height}px`, "left":`${left}px`, "top":`${top}px`});

  // Update Restock Alert
  let restockSelect = document.querySelector('select[name="da-restock-alerts-variant"]');
  let restockSelectOptions = document.querySelectorAll('select[name="da-restock-alerts-variant"] option');
  let size = $(this)[0].innerHTML;

  for (let i = 0; i < restockSelectOptions.length; i++) {
    if (restockSelectOptions[i].label == size) {
      restockSelect.selectedIndex = i;
      break;
    }
  }
}

$(document).ready(function() {
  theme.initialSelectedItem();
});

document.addEventListener('quickview:loaded', theme.initialSelectedItem);

// Scroll down button
$(document).ready(function() {
  const scrollDown = e => {
    const self = e.target;
    const parent = self.closest('.shopify-section');
    const top = parent ? parent.offsetHeight : self.offsetHeight;

    window.scrollTo({ top: (top + 40), behavior: 'smooth' })
  };

  const scrollButton = document.querySelector('.js-scroll-down');
  if(scrollButton) {
    scrollButton.addEventListener('click', scrollDown, false);
  }
});

function lookbookQuickView(evt) {
  const el = evt.target;
  el.classList.toggle('active');

  // Preload product info
  const handle = el.dataset.productHandle;
  const productId = el.dataset.productId;
  const btn = document.querySelector('.js-modal-open-quick-modal-' + productId);
  theme.preloadProductModal(handle, productId, btn);
}

const lookbookButtons = document.querySelectorAll('.lookbook-button');
lookbookButtons.forEach(btn => {
  btn.addEventListener('click', lookbookQuickView, false);
});

// Mix & Match Sliders
$(document).ready(function() {
  const mixMatchSliders = document.querySelectorAll('.mix-match-slider');
  const mixMatchInterfaces = document.querySelectorAll('.mix-match-interface');

  let sliders = {};
  
  mixMatchSliders.forEach((slider, index) => {
    const arrows = slider.closest('.mix-match-slider--outer').querySelector('.slider-arrows');

    sliders[index] = tns({
      container: slider,
      items: 1,
      slideBy: 1,
      autoplay: false,
      center: false,
      nav: false,
      controlsContainer: arrows,
      responsive: {
        480: {
          items: 2,
          center: true
        },
        768: {
          items: 2,
          center: true
        }
      }
    });
  })

  const updateInterface = (container, productPrice, productID, hasSizeGuide, productTitle, productVariants) => {
    let targetIndex;

    let gridElement = container.closest('.mix-match__grid-item');


    if (gridElement.classList.contains('mix-match__collection-1')) {
      targetIndex = 0
    }
    if (gridElement.classList.contains('mix-match__collection-2')) {
      targetIndex = 1
    }

    // get specific variant data as array - variant: [id, title, available, price]
    let variantData = productVariants.split('|');
    variantData = variantData.map((elem) => {
      return elem.split(',');
    })

    // build price label
    let priceHTML = document.createElement('div');
    priceHTML.innerHTML = `
      <h5 class="active-product-price">
      ${productPrice}
      </h5>
    `;

    // build sizes output
    let sizesHTMLOuter = document.createElement('div');
    sizesHTMLOuter.classList.add('interface-form-container');

    let sizesHTML = document.createElement('div');
    sizesHTML.classList.add('interface-form');

    let swatchesHTML = document.createElement('div');
    swatchesHTML.classList.add('interface-form-swatches');

    let sizeLabel = document.createElement('span');
    sizeLabel.classList.add('interface-form-label');
    sizeLabel.innerHTML = 'Size:';

    sizesHTML.appendChild(sizeLabel);

    variantData.forEach((variant) => {
      let tempSizeSwatch = document.createElement('a');
      tempSizeSwatch.setAttribute('data-id', variant[0]);
      tempSizeSwatch.setAttribute('data-price', variant[3]);
      tempSizeSwatch.setAttribute('href', '#');
      tempSizeSwatch.classList.add('mix-match-size');
      variant[2] == 'false' ? tempSizeSwatch.classList.add('sold-out') : '';
      tempSizeSwatch.innerHTML = `<span>${variant[1]}</span>`;

      swatchesHTML.appendChild(tempSizeSwatch);
    })

    sizesHTML.appendChild(swatchesHTML);

    // build size guide btn
    let sizeGuideHTML = document.createElement('div');
    if (hasSizeGuide == 'true') {
      sizeGuideHTML.classList.add('size-guide-link');
      let sizeGuideBtn = document.createElement('a');
      sizeGuideBtn.classList.add('size-guide--fake-btn');
      sizeGuideBtn.setAttribute('href', '#');
      sizeGuideBtn.setAttribute('data-id', productID);
      sizeGuideBtn.innerHTML = 'Size Guide';
  
      sizeGuideHTML.appendChild(sizeGuideBtn);
    }
    
    // build atc btn
    let btnHTML = document.createElement('div');
    btnHTML.innerHTML = `
      <div class="interface-atc-button">
          <a href="#" class="btn btn--secondary mix-match-atc" data-variant-id="">
              Select a size
          </a>
      </div>
    `;

    // get slider interface
    const targetInterface = mixMatchInterfaces[targetIndex];

    // update currect active product title
    targetInterface.querySelector('.active-product-title').innerHTML = productTitle;

    // update Size Guide btn
    targetInterface.querySelector('.size-chart--fake-btn')?.setAttribute('data-id', productID);

    // update currect active product price
    // TODO

    // get interface form
    const interfaceForm = targetInterface.querySelector('.dynamic-content');
    // clear current form
    while (interfaceForm.firstChild) {
      interfaceForm.removeChild(interfaceForm.firstChild);
    }
    // append new form
    interfaceForm.appendChild(priceHTML);

    sizesHTMLOuter.appendChild(sizesHTML)
    hasSizeGuide == 'true' ? sizesHTMLOuter.appendChild(sizeGuideHTML) : '';

    interfaceForm.appendChild(sizesHTMLOuter);

    interfaceForm.appendChild(btnHTML);
  }

  const updateActiveSlide = (info, eventName) => {
    const container = info.container;
    
    const activeSlide = info.container.children[info.index]
    const productPrice = activeSlide.getAttribute('data-product-price');
    const productID = activeSlide.getAttribute('data-product-id');
    const hasSizeGuide = activeSlide.getAttribute('data-size-guide');
    const productTitle = activeSlide.getAttribute('data-product-title');
    const productVariants = activeSlide.getAttribute('data-product-variants');

    updateInterface(container, productPrice, productID, hasSizeGuide, productTitle, productVariants);
  }

  for (let i = 0; i < Object.keys(sliders).length; i++) {
    sliders[i].events.on('indexChanged', updateActiveSlide);
  }

  // Watch for size select
  $(document).on('click', '.mix-match-size', function(e) {
    e.preventDefault();

    if (this.classList.contains('sold-out')) return;

    const parent = this.closest('.mix-match-interface');

    // update size btns
    let sizeSwatches = parent.querySelectorAll('.mix-match-size');
    sizeSwatches.forEach((swatch) => {
      swatch.classList.remove('active');
    })
    this.classList.add('active');

    // update price label
    let priceLabel = parent.querySelector('.active-product-price');
    priceLabel.innerHTML = this.getAttribute('data-price');

    // update ATC button
    let ATCBtn = parent.querySelector('.mix-match-atc');

    ATCBtn.setAttribute('data-variant-id', this.getAttribute('data-id'));
    ATCBtn.innerHTML = 'Add to bag';
  })

  // Click Size Guide Btn
  $(document).on('click', '.size-guide--fake-btn', function(e) {
    e.preventDefault;

    let dataID = this.getAttribute('data-id');
    let realBtn = document.querySelector(`.size-guide-btn--${dataID}`);

    setTimeout(() => {
      realBtn.querySelector('.ks-chart-modal-link').click();
    }, 100);
  })

  // Add to cart
  $(document).on('click', '.mix-match-atc', function(e) {
    e.preventDefault();

    const variantID = this.getAttribute('data-variant-id');

    if (variantID == '') return;

    let data = {
      "id": variantID,
      "quantity": 1
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        // update cart
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            addToCartBtn: self
          }
        }));
      }
    });
  })

});

// START ALSO AVAILABLE IN
theme.GraphQL = {

    config:  {
        storefront_token: 'f7fa0f05b3c0feb109a2f2845fd515e9',
        request_url: theme.routes.storefrontAPI
    },

    sendRequest: function(request, request_group, output_container) {

        if(this.config[request_group] == null) {
            this.config[request_group] = 1;
        } else {
            this.config[request_group]++;
        }

        let return_response = null;

        let settings = {
            'crossDomain': true,
            'url': this.config.request_url,
            'method': 'POST',
            'headers': {
                'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                'Content-Type': 'application/graphql',
            },
            'data': request,
            'success': function(response) {
                theme.GraphQL.config[request_group]--;
                return_response = response;
            },
            'error': function(xhr, errDesc) {
                theme.GraphQL.config[request_group]--;
                console.log(errDesc);
            }
        };
        $.ajax(settings)
            .done(function() {
                if(request_group === "also-available") {
                    theme.AlsoAvailableIn.buildOutput(return_response);
                }
                theme.GraphQL.cleanUp(request_group);
            });
    },

    cleanUp: function(request_group) {
        if(theme.GraphQL.config[request_group] < 1) {
            $('body').trigger(request_group+":loaded");
            delete this.config[request_group];
        }
    }
};

theme.AlsoAvailableIn = (function() {
    let config = {
        request_query: '',
        current_product: '',
        product_name: '',
        image_url_structure: '',
    };

    function init(container) {
        let $container = this.$container = $(container);
        config.request_query = $container.data('request-query');
        config.current_product = $container.data('current-product');
        config.product_name = $container.data('product-name');
        config.image_url_structure = $container.data('image-url-structure');

        let request_query = `
          {
            products(first: 100, query: "title:`+config.request_query+`*") {
              edges {
                node {
                  availableForSale
                  title
                  handle
                }
              }
            }
          }
        `;

        try {
            theme.GraphQL.sendRequest(request_query, "also-available");
        }
        catch(err) {
            console.error("Errors in GraphQL: "+err);
        }

    }

    function buildOutput(response) {
        let output_html = '';
        let product_arr = response.data.products.edges;

        if(product_arr.length <= 1) {
            return;
        }

        this.$container.show();

        const requestQuery = this.$container.data('request-query');
        const filteredProducts = product_arr.filter(p => p.node.title.includes(requestQuery));
        const regex = /\(([^)]+)\)/;

        // Builds swatches products
        output_html = filteredProducts.map(p => {
          const matches = regex.exec(p.node.title);
          return `
            <a class="product-swatch-button${ p.node.handle === config.current_product ? ' aa-swatch--current' : ''}" href="/products/${p.node.handle}"
              style="--bgColor: ${matches[1].toLowerCase()}; --bgImg: url(${config.image_url_structure.replace("---productTitle---", matches[1].toLowerCase().replace(' ', '-'))};" title="${matches[1]}">
            </a>
          `;
        }).join('');

        // Select current swatch and displays colour name
        const currentSwatch = filteredProducts.find(p => p.node.handle === config.current_product);
        if (currentSwatch) {
          let matches = regex.exec(currentSwatch.node.title);
          this.$container.find('#current-product-color').append(matches[1]);
        }

        this.$container.find('.aa-container').append(output_html);
        document.dispatchEvent(new CustomEvent('swatchColors:loaded'));
    }

    return {
        init: init,
        buildOutput: buildOutput
    };

})();

$(document).ready(function() {
    $('[data-section-type="also-available"]').each(function() {
        theme.AlsoAvailableIn.init(this);
    });
});
// END ALSO AVAILABLE IN


// START PRODUCT ITEM COLOUR SWATCHES
theme.GraphQL2 = {

    config:  {
        storefront_token: 'f7fa0f05b3c0feb109a2f2845fd515e9',
        request_url: theme.routes.storefrontAPI
    },

    sendRequest: function(request, request_group, output_container, temp_data) {

        if(this.config[request_group] == null) {
            this.config[request_group] = 1;
        } else {
            this.config[request_group]++;
        }

        let return_response = null;

        let settings = {
            'crossDomain': true,
            'url': this.config.request_url,
            'method': 'POST',
            'headers': {
                'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                'Content-Type': 'application/graphql',
            },
            'data': request,
            'success': function(response) {
                theme.GraphQL2.config[request_group]--;
                return_response = response;
            },
            'error': function(xhr, errDesc) {
                theme.GraphQL2.config[request_group]--;
                console.log(errDesc);
            }
        };
        $.ajax(settings)
            .done(function() {
                if(request_group === "also-available") {
                    theme.ProductColorSwatch.buildOutput(return_response, output_container, temp_data);
                }
                theme.GraphQL2.cleanUp(request_group);
            });
    },

    cleanUp: function(request_group) {
        if(theme.GraphQL2.config[request_group] < 1) {
            $('body').trigger(request_group+":loaded");
            delete this.config[request_group];
        }
    }
};

theme.ProductColorSwatch = (function() {
    let config = {
        request_query: '',
        current_product: '',
        product_name: '',
        image_url_structure: '',
    };

    let swatch_html = `
    <span class="product-swatch-button product-swatch-button--colour-swatch ###swatchCurrent###"
        data-image="###productImage###"
        data-second-image="###secondProductImage###"
        data-url="###productURL###"
        data-product="###productHandle###"
        data-title="###productTitle###"
        data-id="###productID###"
        data-first-var-id="###productFirstVarID###"
        data-price="###productPrice###"
        data-compare-at-price="###productComparePrice###"
        data-on-sale="###onSale###"
        data-sizes='###variantSizes###'
        data-label-tags='###labelTags###'
        title='###swatchTitle###'
        style="background-image:url(###swatchURL###);">
    </span>
    `;
    function init(container) {
        let $container = this.$container = $(container);
        config.request_query = $container.data('request-query');
        config.current_product = $container.data('current-product');
        config.product_name = $container.data('product-name');
        config.image_url_structure = $container.data('image-url-structure');

        let temp_data = {
            request_query: $container.data('request-query'),
            current_product: $container.data('current-product'),
            product_name: $container.data('product-name'),
            image_url_structure: $container.data('image-url-structure'),
        };

        let request_query = `
          {
            products(first: 250, query: "title:`+temp_data.request_query+`*") {
              edges {
                node {
                  id
                  tags
                  compareAtPriceRange {
                    minVariantPrice {
                      amount
                    }
                  }
                  priceRange {
                    minVariantPrice {
                        amount
                    }
                  }
                  variants(first: 10) {
                      edges {
                          node {
                              availableForSale
                              id
                              title
                          }
                      }
                  }
                  onlineStoreUrl
                  availableForSale
                  title
                  handle
                  images(first: 2) {
                      edges {
                          node {
                              url
                          }
                      }
                  }
                }
              }
            }
          }
        `;

        try {
            theme.GraphQL2.sendRequest(request_query, "also-available", $container, temp_data);
        }
        catch(err) {
            console.error("Errors in GraphQL: "+err);
        }

    }

    function buildOutput(response, output_container, temp_data) {
        let output_html = '';
        let product_arr = response.data.products.edges;
        if(product_arr.length <= 1) {
            return;
        }

        output_container.show();

        let count = 0;
        for (let i=0;i<product_arr.length;i++) {
            if (count > 6) {
                break;
            }

            if (!product_arr[i].node.title.includes(temp_data.request_query)) {
                continue;
            }

            let product_title = product_arr[i].node.title.split("(");

            if (!product_arr[i].node.availableForSale) {
                continue;
            }

            // variant sizes
            let variant_arr = product_arr[i].node.variants.edges;
            let sizes_html;

            let sizes_inner_html = '';
            for (let j = 0; j<variant_arr.length; j++) {
                let temp = `
                <li class="size-swatch size-swatch--${variant_arr[j].node.title}${variant_arr[j].node.availableForSale ? '' : ' unavailable'}">
                  <button type="button" class="size-add-to-cart js-product-grid-atc" data-variant-id="${(variant_arr[j].node.id).split('/').pop()}">${variant_arr[j].node.title}</button>
                </li>
                `;

                sizes_inner_html = sizes_inner_html += temp;
            }

            sizes_html = `
            <div class="quick-add-to-cart__panel--sizes">
                ${sizes_inner_html}
            </div>
            `;
            // end variant sizes

            let temp = product_title[1];
            if(temp) {
              temp = temp.split(")");
              temp = temp[0].replaceAll(' ', '-');
              temp = temp.replaceAll('/', '-');
            } else {
              temp = '';
            }
            let swatch_url = temp_data.image_url_structure.replace("---productTitle---",temp.toLowerCase());
            let output = swatch_html.replace("###swatchURL###",swatch_url);
            let productURL = "/products/"+product_arr[i].node.handle;
            if(productURL) {
              output = output.replace("###productURL###",productURL);
              output = output.replace("###productHandle###", product_arr[i].node.handle);
            }
            output = output.replace("###productImage###", product_arr[i].node.images.edges[0].node.url);
            if(product_arr[i].node.images.edges[1]) {
              output = output.replace("###secondProductImage###", product_arr[i].node.images.edges[1].node.url);
            } else {
              output = output.replace("###secondProductImage###", product_arr[i].node.images.edges[0].node.url);
            }

            output = output.replace("###productTitle###", product_arr[i].node.title);

            let convertedID = (product_arr[i].node.id).split('/').pop();
            output = output.replace("###productID###", convertedID);

            let convertedVarID = (product_arr[i].node.variants.edges[0].node.id).split('/').pop();
            output = output.replace("###productFirstVarID###", convertedVarID);

            output = output.replace("###variantSizes###", sizes_html);

            let prodPrice = new Intl.NumberFormat('en-AU', {
                style: 'currency',
                currency: Shopify.currency.active
            }).format(product_arr[i].node.priceRange.minVariantPrice.amount);
            output = output.replace("###productPrice###", prodPrice);

            let prodComparePrice = new Intl.NumberFormat('en-AU', {
              style: 'currency',
              currency: Shopify.currency.active
            }).format(product_arr[i].node.compareAtPriceRange.minVariantPrice.amount);
            output = output.replace("###productComparePrice###", prodComparePrice);

            output = output.replace("###onSale###", prodPrice < prodComparePrice);

            let tags = product_arr[i].node.tags;
            let labelTags = [];
            tags.forEach(elem => {
              if (elem.includes('_label_')) {
                labelTags.push(elem.replace('_label_', '').trim());
              }
            });
            labelTags = JSON.stringify(labelTags);
            output = output.replace("###labelTags###", labelTags);

            let splitTitle = product_arr[i].node.title.split(' (');
            let removeLastBracket = splitTitle[splitTitle.length - 1].split(')');
            let titleColour = removeLastBracket[0];
            output = output.replace('###swatchTitle###', titleColour);
            if(product_arr[i].node.handle === temp_data.current_product) {
                output = output.replace("###swatchCurrent###","aa-swatch--current aa-swatch--initial");
            } else {
                output = output.replace("###swatchCurrent###", "");
            }
            output_html += output;
            count++;
        }
        
        output_container.find('.aa-container').append(output_html);
        document.dispatchEvent(new CustomEvent('swatchColors:loaded'));
    }

    return {
        init: init,
        buildOutput: buildOutput
    };

})();

$(document).ready(function() {
    $('[data-section-type="product-color-swatch"]').each(function() {
        this.setAttribute('data-section-type', 'product-color-swatch--full');
        theme.ProductColorSwatch.init(this);
    });
});

$(document).ready(function() {
    // need to delay for "dynamic product recommendations" section
    document.addEventListener('recommendations:loaded', () => {
        $('[data-section-type="product-recommendations"] [data-section-type="product-color-swatch"]').each(function() {
            this.setAttribute('data-section-type', 'product-color-swatch--full');
            theme.ProductColorSwatch.init(this);
        });
        pgAtcBtnsFunction();
    })
    // need to delay for Boost PFS sorting
    document.addEventListener('updateBoostSort', () => {
        $('[data-section-type="product-color-swatch"]').each(function() {
            this.setAttribute('data-section-type', 'product-color-swatch--full');
            theme.ProductColorSwatch.init(this);
        });
        pgAtcBtnsFunction();
    })
    document.addEventListener('plpMoreLoaded', () => {
      $('[data-section-type="product-color-swatch"]').each(function() {
            this.setAttribute('data-section-type', 'product-color-swatch--full');
            theme.ProductColorSwatch.init(this);
        });
        pgAtcBtnsFunction();
    })
});

$(document).on('click', '.product-swatch-button--colour-swatch', function(e) {
    e.preventDefault;

    let url = this.getAttribute('data-url');
    let image = this.getAttribute('data-image');
    let hoverImage = this.getAttribute('data-second-image');
    let title = this.getAttribute('data-title');
    let ID = this.getAttribute('data-id');
    let firstVarID = this.getAttribute('data-first-var-id');
    let price = this.getAttribute('data-price');
    let compareAtPrice = this.getAttribute('data-compare-at-price');
    let onSale = this.getAttribute('data-on-sale');
    let sizes = this.getAttribute('data-sizes');
    let labelTags = this.getAttribute('data-label-tags');
    let container = this.closest('.grid-product');

    // change active swatch
    container.querySelector('.aa-swatch--current')?.classList.remove('aa-swatch--current');
    this.classList.add('aa-swatch--current');

    // update label
    labelTags = JSON.parse(labelTags);
    // remove all current labels (Boost)
    let boostLabelDiv = container.querySelector('.boost-pfs-filter-product-item-label');
    if (boostLabelDiv) {
      while (boostLabelDiv.firstChild) {
        boostLabelDiv.removeChild(boostLabelDiv.firstChild)
      }
    }
    // remove all current labels (Default)
    let defaultContentDiv = container.querySelector('.grid-product__content');
    let defaultLabelDiv = defaultContentDiv.querySelector('.grid-product__tag');
    if (defaultLabelDiv) {
      defaultContentDiv.removeChild(defaultLabelDiv);
    }
    // create new label
    let newLabel;
    if (labelTags.length > 0) {
      newLabel = document.createElement('span');
      newLabel.classList.add('grid-product__tag', 'grid-product__tag--custom');
      newLabel.innerHTML = labelTags[0];
    }
    // add new label (Default + Boost)
    if(newLabel && defaultContentDiv) {
      defaultContentDiv.appendChild(newLabel);
    }
    
    // update image
    let currentImage = container.querySelector('.grid-product__image');
    if (currentImage) {
        container.querySelector('.image-wrap').innerHTML = '';
    }
    let currentVideo = container.querySelector('.image-wrap video');
    if (currentVideo) {
      currentVideo.closest('.image-wrap').innerHTML = '';
    }
    container.querySelector('.image-wrap').style.backgroundImage = `url('${image}')`;
    container.querySelector('.image-wrap').style.backgroundSize = "cover";

    // Update hover image
    let hoverCurrentImage = container.querySelector('.grid-product__secondary-image img');
    if(hoverCurrentImage) {
      container.querySelector('.grid-product__secondary-image').innerHTML = '';
    }
    let hoverCurrentVideo = container.querySelector('.grid-product__secondary-image video');
    if (hoverCurrentVideo) {
      hoverCurrentVideo.closest('.grid-product__secondary-image').innerHTML = '';
    }

    let hoverImageContainer = container.querySelector('.grid-product__secondary-image');
    if(hoverImageContainer) {    
      container.querySelector('.grid-product__secondary-image').style.backgroundImage = `url('${hoverImage}')`;
      container.querySelector('.grid-product__secondary-image').style.backgroundSize = "cover";
    }

    // update links
    container.querySelector('.grid-product__link a').setAttribute('href', url);

    // update title + wishlist (wishlist needs to be reinitialised)
    let titleContainer = container.querySelector('.grid-product__title');
    // let wishlistBtn = titleContainer.querySelector('.swym-button');
    let titleHTML = `${title}`;
    // if (wishlistBtn) {
    //   let temp = `
    //   <button class="swym-button swym-add-to-wishlist-view-product product_${ID} swym-icon swym-heart swym-loaded" data-swaction="addToWishlist" data-product-id="${ID}" data-variant-id="${firstVarID}" data-product-url="${url}" aria-label="Add to Wishlist">
    //     <span class="swym-tooltip swym-inject swym-tooltip-clickable">
    //       <span class="swym-tooltip-text">
    //         Add to wishlist
    //       </span>
    //     </span>
    //   </button>
    //   `;
    //   titleHTML += temp;
    // }
    titleContainer.innerHTML = titleHTML;

    // update price
    container.querySelector('.grid-product__price .money').innerHTML = price;
    container.querySelector('.grid-product__price .money').setAttribute('data-currency-aud', price);

    // update compare at price
    // remove current compare at price
    let priceDiv = container.querySelector('.grid-product__price');
    let priceOriginal = container.querySelector('.grid-product__price--original');
    if (priceDiv && priceOriginal) {
      priceDiv.removeChild(priceOriginal);
    }
    // add new compare at price
    if (compareAtPrice && compareAtPrice != '$0.00') {
      let compareAtSpan = document.createElement('span');
      compareAtSpan.classList.add('grid-product__price--original');
      compareAtSpan.innerHTML = `<span class="money" data-currency-aud="${compareAtPrice}">${compareAtPrice}</span>`;
      priceDiv.appendChild(compareAtSpan);
    }

    // update quick add
    container.querySelector('.grid-product__sizes').innerHTML = sizes;
    pgAtcBtnsFunction();

})
// END PRODUCT ITEM COLOUR SWATCHES

// Cart Cross-Sell
$(document).ready(function() {
  // toggle panel
  $(document).on('click', '.cart-cross-sell__btn', function(e) {
    e.preventDefault();

    this.classList.toggle('active');

    if (this.classList.contains('active')) {
      const crossSell = this.closest('.cart-cross-sell');
      crossSell.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    }
  });

  const addCrossSellItemToCart = async e => {
    const self = e.target;
    const parent = self.closest('.simple-product-grid-item');
    const variantEl = parent.querySelector('[name="variant"]');
    const variantsEl = parent.querySelector('[name="variants"]');
    const id = variantEl ? variantEl.value : variantsEl ? variantsEl.options[variantsEl.selectedIndex].value : null;

    if (!id || id === 'select size') {
      if (id === 'select size') variantsEl.focus();
      return;
    }

    let formData = {
      'items': [{
        'id': id,
        'quantity': 1
      }]
    };

    self.classList.add('btn--loading');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (res.ok) 
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }

    catch (err) {
      console.log(err);
    }
    finally {
      self.classList.remove('btn--loading');
    }
  }

  const crossSellBtns = document.querySelectorAll('.js-add-cross-sell');
  crossSellBtns.forEach(btn => {
    btn.addEventListener('click', addCrossSellItemToCart, false);
  });
});

// Matching Set
$(document).ready(function() {
  // update ATC btn on variant select
  $(document).on('change', '.product-matching-set__size-select', function(e) {
    e.preventDefault();

    let selectedVariantID = this.options[this.selectedIndex].value;
    if (selectedVariantID == '') return;

    let parent = this.closest('.product-matching-set__grid-item');

    let atcBtn = parent.querySelector('.product-matching-set__atc-btn');
    atcBtn.setAttribute('data-variant-id', selectedVariantID);
    atcBtn.classList.remove('disabled')
  })

  // add to cart
  $(document).on('click', '.product-matching-set__atc-btn', function(e) {
    e.preventDefault();

    let variantID = this.getAttribute('data-variant-id');
    if (!variantID) return;

    let data = {
      "id": variantID,
      "quantity": 1
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        // update cart
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));
      }
    });
  })
});

// Boost sort by 
$('.boost-pfs-filter-top-sorting-wrapper').on('click', function() {
  $('.boost-pfs-filter-filter-dropdown').toggleClass('active');
});

window.addEventListener('DOMContentLoaded', () => {
    // PDP recomendations and recently viewed tabs
    let tabbedContent = document.querySelectorAll('.recommendation-tab-content');
    let tabLinks = document.querySelectorAll('.recommendation-tab-title');
     $(document).on('click', '.recommendation-tab-title', function(e) {
       
        let contentNum = e.target.getAttribute('data-tab-id');
        tabbedContent.forEach((element, index) => {
        element.classList.remove('active');
        })
        tabLinks.forEach((element, index) => {
        element.classList.remove('active');
        })
        e.target.classList.add('active');
        let content = document.querySelector(`.recommendation-tab-content[data-tab-id="${contentNum}"]`);
        content.classList.add('active');
    });
});


// Function that hides foursixty section in PDP if foursixty is empty
const hideFourSixtySection = e => {
  const foursixty = document.getElementById('foursixty-hideable-container');
  const sectionContainer = foursixty?.closest('.shopify-section');
  const callback = (mutationList, observer) => {
    const hasChildList = mutationList.some(mutation => mutation.type === 'childList');
    
    if (!hasChildList) sectionContainer.classList.add('hide');
    observer.disconnect();
  }
  const observer = new MutationObserver(callback);
  if (!foursixty) return;
  observer.observe(foursixty, { attributes: true, childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', hideFourSixtySection, false);